module.exports = __webpack_public_path__ + "static/img/machine2.b9e7defe.png";